/**
 * @generated SignedSource<<3bfebb3bf678e0e1b69c5244627ea4c6>>
 * @relayHash 8c2a28b2742e975df8df865d5d95c688
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0eeabc09ee887c36e9f8864d01bf22bb46773618fb12f5da9972c2f73408a9fe

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type JiraSetIssueSearchHideDoneItemsInput = {
  hideDoneItems: boolean;
  viewId: string;
};
export type useUpdateHideDoneMutation234Mutation$variables = {
  input: JiraSetIssueSearchHideDoneItemsInput;
};
export type useUpdateHideDoneMutation234Mutation$data = {
  readonly jira_setIssueSearchHideDoneItems: {
    readonly errors: ReadonlyArray<{
      readonly extensions: {
        readonly statusCode: number | null | undefined;
      } | null | undefined;
      readonly message: string | null | undefined;
    }> | null | undefined;
    readonly success: boolean;
  } | null | undefined;
};
export type useUpdateHideDoneMutation234Mutation = {
  response: useUpdateHideDoneMutation234Mutation$data;
  variables: useUpdateHideDoneMutation234Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "success"
},
v3 = {
  "kind": "ScalarField",
  "name": "message"
},
v4 = {
  "kind": "ScalarField",
  "name": "statusCode"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useUpdateHideDoneMutation234Mutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "JiraSetIssueSearchHideDoneItemsPayload",
        "kind": "LinkedField",
        "name": "jira_setIssueSearchHideDoneItems",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  (v4/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useUpdateHideDoneMutation234Mutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "JiraSetIssueSearchHideDoneItemsPayload",
        "kind": "LinkedField",
        "name": "jira_setIssueSearchHideDoneItems",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "__typename"
                  },
                  (v4/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "id"
                      }
                    ],
                    "type": "BulkMutationErrorExtension"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "0eeabc09ee887c36e9f8864d01bf22bb46773618fb12f5da9972c2f73408a9fe",
    "metadata": {},
    "name": "useUpdateHideDoneMutation234Mutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "08f9d1b39c2b08023c47064c6e435618";

export default node;
